import React from "react";
import { ModalDelete } from "./Delete";

function Modals() {
  const modals = [
    {
      id: "delete",
      component: ModalDelete,
    },
  ];

  return (
    <>
      {modals.map((m) => (
        <m.component key={m.id} />
      ))}
    </>
  );
}

Modals.Delete = ModalDelete;

export { Modals };
